import './SitePage.css';

const pageDefinitions = {
  '/search': {
    eyebrow: 'TRILLIUM PAWS',
    title: 'Search',
    description: 'Find the nutrition, care, and essentials your companion needs to thrive.',
    action: 'Browse all products',
    actionHref: '/products',
  },
  '/account': {
    eyebrow: 'TRILLIUM PAWS',
    title: 'Your Account',
    description: 'Your orders, saved details, and Trillium Paws care journey in one place.',
    action: 'Start shopping',
    actionHref: '/products',
  },
  '/cart': {
    eyebrow: 'SHOPPING BAG',
    title: 'Your Cart',
    description: 'Your cart is ready for the next step toward happier, healthier days.',
    action: 'Continue shopping',
    actionHref: '/products',
  },
  '/products': {
    eyebrow: 'SHOP',
    title: 'All Products',
    description: 'Thoughtfully made nutrition, care, and everyday essentials for happier, healthier pets.',
    action: 'Browse supplements',
    actionHref: '/collections/supplements',
  },
  '/collections/supplements': {
    eyebrow: 'SHOP',
    title: 'Dog Supplements',
    description: 'Targeted, vet-inspired nutrition to support your dog through every stage of life.',
    action: 'Explore soft chews',
    actionHref: '/products',
  },
  '/collections/best-sellers': {
    eyebrow: 'SHOP',
    title: 'Best Sellers',
    description: 'The trusted Trillium Paws favorites pet parents reach for again and again.',
    action: 'View all products',
    actionHref: '/products',
  },
  '/collections/new-arrivals': {
    eyebrow: 'SHOP',
    title: 'New Arrivals',
    description: 'Fresh additions to our collection of thoughtful nutrition and everyday care.',
    action: 'View all products',
    actionHref: '/products',
  },
  '/collections/supplements/daily-wellness': {
    eyebrow: 'DOG SUPPLEMENTS',
    title: 'Daily Wellness',
    description: 'Simple daily support for energy, vitality, and the little moments that make a life together.',
    action: 'Explore supplements',
    actionHref: '/collections/supplements',
  },
  '/collections/supplements/joint-support': {
    eyebrow: 'DOG SUPPLEMENTS',
    title: 'Joint Support',
    description: 'Nourishing support for comfortable movement, active days, and every adventure ahead.',
    action: 'Explore supplements',
    actionHref: '/collections/supplements',
  },
  '/collections/pet-care': {
    eyebrow: 'SHOP',
    title: 'Pet Care',
    description: 'Simple, dependable care products designed around the companions who mean the most.',
    action: 'View all products',
    actionHref: '/products',
  },
  '/collections/toys': {
    eyebrow: 'SHOP',
    title: 'Toys & Accessories',
    description: 'Playful, practical essentials for curious pups and the adventures you share.',
    action: 'View all products',
    actionHref: '/products',
  },
  '/collections/essentials': {
    eyebrow: 'SHOP',
    title: 'Travel & Essentials',
    description: 'Useful everyday companions for walks, weekends away, and everything between.',
    action: 'View all products',
    actionHref: '/products',
  },
  '/collections/grooming': {
    eyebrow: 'PET CARE',
    title: 'Grooming',
    description: 'Gentle essentials to help your companion feel fresh, comfortable, and cared for.',
    action: 'View pet care',
    actionHref: '/collections/pet-care',
  },
  '/collections/pet-care/essentials': {
    eyebrow: 'PET CARE',
    title: 'Care Essentials',
    description: 'Practical everyday tools for a more comfortable, connected life with your pet.',
    action: 'View pet care',
    actionHref: '/collections/pet-care',
  },
  '/about': {
    eyebrow: 'ABOUT',
    title: 'Our Story',
    description: 'Trillium Paws began with a simple belief: better pet nutrition creates brighter tomorrows.',
    action: 'Why Trillium Paws',
    actionHref: '/about/why-trillium-paws',
  },
  '/about/why-trillium-paws': {
    eyebrow: 'ABOUT',
    title: 'Why Trillium Paws',
    description: 'Clean ingredients, thoughtful formulas, and nutritional integrity for the lives pets share with us.',
    action: 'Explore supplements',
    actionHref: '/collections/supplements',
  },
  '/blog': {
    eyebrow: 'RESOURCES',
    title: 'Blog & Resources',
    description: 'Practical guidance and thoughtful insights to help you care for your pet with confidence.',
    action: 'Visit the FAQ',
    actionHref: '/faq',
  },
  '/blog/wellness-tips': {
    eyebrow: 'RESOURCES',
    title: 'Wellness Tips',
    description: 'Useful, approachable ideas for supporting your pet’s health at home every day.',
    action: 'Explore resources',
    actionHref: '/blog',
  },
  '/faq': {
    eyebrow: 'RESOURCES',
    title: 'Frequently Asked Questions',
    description: 'Find clear answers about our products, ingredients, orders, and everyday pet care.',
    action: 'Contact us',
    actionHref: '/contact',
  },
  '/contact': {
    eyebrow: 'CUSTOMER CARE',
    title: 'Contact Us',
    description: 'Our team is here to help with product questions, order support, and thoughtful pet care guidance.',
    action: 'Track an order',
    actionHref: '/track-order',
  },
  '/track-order': {
    eyebrow: 'CUSTOMER CARE',
    title: 'Track Order',
    description: 'Keep an eye on your Trillium Paws order from our door to yours.',
    action: 'Contact customer care',
    actionHref: '/contact',
  },
  '/shipping-policy': {
    eyebrow: 'CUSTOMER CARE',
    title: 'Shipping Policy',
    description: 'Everything you need to know about delivery timing, order processing, and shipping support.',
    action: 'Contact us',
    actionHref: '/contact',
  },
  '/returns-refunds': {
    eyebrow: 'CUSTOMER CARE',
    title: 'Returns & Refunds',
    description: 'We want every Trillium Paws experience to feel right. Learn about returns and refund support.',
    action: 'Contact customer care',
    actionHref: '/contact',
  },
  '/privacy-policy': {
    eyebrow: 'CUSTOMER CARE',
    title: 'Privacy Policy',
    description: 'How Trillium Paws respects, uses, and protects the information you share with us.',
    action: 'Contact us',
    actionHref: '/contact',
  },
  '/terms-of-service': {
    eyebrow: 'CUSTOMER CARE',
    title: 'Terms of Service',
    description: 'The terms that guide your use of the Trillium Paws website and services.',
    action: 'Return home',
    actionHref: '/',
  },
};

export function getPageDefinition(pathname) {
  return pageDefinitions[pathname] || null;
}

export default function SitePage({ page }) {
  return (
    <>
      <main className="site-page">
        <div className="site-page__inner">
          <p className="site-page__eyebrow">{page.eyebrow}</p>
          <h1>{page.title}</h1>
          <p className="site-page__description">{page.description}</p>
          <a className="site-page__action" href={page.actionHref}>{page.action}<span aria-hidden="true">→</span></a>
        </div>
      </main>
    </>
  );
}
